const parseDate = (dateStr: string | null): Date | null => {
  if (!dateStr) return null
  const d = new Date(dateStr)
  return isNaN(d.getTime()) ? null : d
}

export function getDefaultDateRange(): { gte: Date; lte: Date } {
  const now = new Date()
  const gte = new Date(now)
  gte.setDate(gte.getDate() - 60)
  gte.setHours(0, 0, 0, 0)
  const lte = new Date(now)
  lte.setDate(lte.getDate() + 60)
  lte.setHours(23, 59, 59, 999)
  return { gte, lte }
}

export function loadFiltersFromUrl() {
  const searchParams = new URLSearchParams(location.search)
  const defaultRange = getDefaultDateRange()

  const filters = {
    statuses: ['ACTIVE'] as string[],
    categories: [] as string[],
    searchText: '',
    page: 1,
    pageSize: 20,
    sortField: null as string | null,
    sortDirection: null as 'asc' | 'desc' | null,
    expirationDateGte: defaultRange.gte as Date | null,
    expirationDateLte: defaultRange.lte as Date | null,
  }

  const statuses = searchParams.get('statuses')
  if (statuses) filters.statuses = statuses.split(',').filter(Boolean)

  const categories = searchParams.get('categories')
  if (categories) filters.categories = categories.split(',').filter(Boolean)

  const searchText = searchParams.get('searchText')
  if (searchText) filters.searchText = searchText

  const page = searchParams.get('page')
  if (page) {
    const parsed = parseInt(page, 10)
    if (!isNaN(parsed)) filters.page = parsed
  }

  const pageSize = searchParams.get('pageSize')
  if (pageSize) {
    const parsed = parseInt(pageSize, 10)
    if (!isNaN(parsed)) filters.pageSize = parsed
  }

  const sortField = searchParams.get('sortField')
  if (sortField) filters.sortField = sortField

  const sortDirection = searchParams.get('sortDirection')
  if (sortDirection === 'asc' || sortDirection === 'desc') {
    filters.sortDirection = sortDirection
  }

  const parsedGte = parseDate(searchParams.get('expirationDateGte'))
  if (parsedGte) filters.expirationDateGte = parsedGte

  const parsedLte = parseDate(searchParams.get('expirationDateLte'))
  if (parsedLte) filters.expirationDateLte = parsedLte

  return filters
}
